
import React, { useContext } from "react";
import { FaHardHat, FaUserShield, FaNotesMedical, FaSearchPlus } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './ComplianceGlobal.css';
import BannerImage from './compliance_hero.png';

function ISO45K1Comp() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/iso-45001-compliance');
    } else {
      navigate('/login', { state: { from: '/booking/iso-45001-compliance' } });
    }
  };

  return (
    <div className="compliance-page">
      <div className="compliance-max-width">

        {/* --- HERO --- */}
        <div className="compliance-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Occupational Health</span>
          <h1 className="hero-title">ISO 45001 Compliance</h1>
          <p className="hero-subtitle">
            The gold standard for workplace safety. Proactively preventing work-related
            injury and ill health.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Get Complied <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Safety Management System</h2>
              <p className="article-text">
                ISO 45001 is the world's first International Standard for occupational health and safety (OH&S).
                It provides a framework to increase safety, reduce workplace risks and enhance health and well-being at work,
                enabling an organization to proactively improve its OH&S performance.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Hazard Identification</h2>
              <p className="article-text">
                The core of ISO 45001 is risk assessment. Organizations must identify hazards (physical, chemical, biological,
                psychosocial) and mitigate them before an incident occurs. This shift from "reactive" to "proactive"
                is what saves lives.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Worker Participation</h2>
              <p className="article-text">
                Compliance requires the active participation of non-managerial workers. Safety is not a "top-down" directive;
                it is a collaborative effort involving consultation and participation of workers at all levels.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Key Components</h4>
              <ul className="key-list">
                <li><FaUserShield className="check-icon" /> Leadership Commitment</li>
                <li><FaHardHat className="check-icon" /> Worker Participation</li>
                <li><FaSearchPlus className="check-icon" /> Risk Assessment</li>
                <li><FaNotesMedical className="check-icon" /> Health Surveillance</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Workplace Safety</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Achieve ISO 45001 compliance.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ISO45K1Comp;
